$(document).ready(function(){
    $('.sidebar-experts-slider').slick({
        slidesToShow: 1,
        infinite: true,
        prevArrow: $('.expert-controls .left'),
        nextArrow: $('.expert-controls .right'),
    });



    // $('#main-header').hcSticky({
    //     stickTo: $('#main-content'),
    //     mobileFirst: true,
    //     responsive: {
    //         1200: {
    //             disable: true
    //         }
    //     }
    // });

});

var cooks = document.cookie;    // Récupératon des cookies
var name = "tarteaucitron=";    
var decodedCookie = decodeURIComponent(cooks);      // Décryptage des cookies
var ca = decodedCookie.split(';');
var analytics = false;
for(var i = 0; i <ca.length; i++) {     // On boucle sur tous les cookies
    var c = ca[i];
    while (c.charAt(0) == ' ') {
        c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {     // Si la chaine 'name' apparait dans le cookie, c'est le bon
        analytics = c.substring(name.length, c.length);
    }
}
if(analytics){
    if(analytics.indexOf('analytics=wait') != -1){      // Si Analytics est sur wait, on le passe à true (wait = initialisé par le script mais pas encore touché par l'utilisateur)
        document.cookie = name+analytics.replace('analytics=wait','analytics=true');
    }
}else{      // Si le cookie n'est pas trouvé, on l'initialise
    document.cookie = name+'!analytics=true';
}

tarteaucitron.init({
    "privacyUrl": "/politique-gestion-donnees/",
    "hashtag": "#tarteaucitron",
    "cookieName": "tarteaucitron",
    "AcceptAllCta" : true,
    "DenyAllCta": true,
    "handleBrowserDNTRequest": false,
    "moreInfoLink": true,
    "useExternalCss": true,
    "highPrivacy": true,
    "orientation": "bottom",
    "adblocker": false,
    "showAlertSmall": false,
    "cookieslist": true,
    "removeCredit": true,
    'alertBigPrivacy': "Ce site utilise des cookies pour vous garantir la meilleure expérience. Si vous continuez à l’utiliser, vous acceptez leurs utilisation, néanmoins cliquez ici pour indiquer ce que vous souhaitez activer.",
});

(tarteaucitron.job = tarteaucitron.job || []).push('youtube');

// tarteaucitron.user.analyticsUa = 'UA-2405120-101';
tarteaucitron.user.analyticsUa = code_analytics;
tarteaucitron.user.analyticsMore = function () { /* add here your optionnal ga.push() */ };
(tarteaucitron.job = tarteaucitron.job || []).push('analytics');

if (gtag_ua != "") {
    tarteaucitron.user.gtagUa = gtag_ua;
    tarteaucitron.user.gtagMore = function () {};
    (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
}